import { createContext, useContext } from 'react'

export const AccordionHiddenContext = createContext<boolean>(false)

export function useAccordionHiddenContext() {
  return useContext(AccordionHiddenContext)
}
